<div class="char-block">
  <div class="char-block__head">
    <h2 class="char-block__head-title">
      {{ "ANALYTICS_PAGE.PAYMENTS" | translate }}
    </h2>

    <div class="char-block__date-filter">
      <button
        [class.active]="dateFilter === dateState.Week"
        (click)="setTimeFrame(dateState.Week)"
        class="date_btn">
        {{ "ANALYTICS_PAGE.WEEK" | translate }}
      </button>
      <button
        [class.active]="dateFilter === dateState.Month"
        (click)="setTimeFrame(dateState.Month)"
        class="date_btn">
        {{ "ANALYTICS_PAGE.MONTH" | translate }}
      </button>
      <button
        [class.active]="dateFilter === dateState.Year"
        (click)="setTimeFrame(dateState.Year)"
        class="date_btn">
        {{ "ANALYTICS_PAGE.YEAR" | translate }}
      </button>
    </div>
  </div>

  <hr />

  <div
    [class.hidden]="isDataValid"
    class="char-block__empty">
    <h2 class="char-block__empty-title">
      {{ "ANALYTICS_PAGE.EMPTY_DATA" | translate }}
    </h2>

    <p class="char-block__empty-description">
      {{ "ANALYTICS_PAGE.EMPTY_DESCRIPTION_HEADER" | translate }}
    </p>

    <p class="char-block__empty-description">
      {{ "ANALYTICS_PAGE.EMPTY_DESCRIPTION_INFO" | translate }}
      <a routerLink="/support"> {{ "ANALYTICS_PAGE.EMPTY_DESCRIPTION_SUPPROT" | translate }}</a>
      .
    </p>
  </div>

  <div [class.hidden]="!isDataValid">
    <div class="char-block__main">
      <div class="char-block__payment">
        <div class="char-block__payment-item">
          <span class="payment-title"> {{ "ANALYTICS_PAGE.TOTAL_PAYMENT_SUM" | translate }}</span>
          <span class="payment-currency">{{ "₸" + totalPayments.toFixed(2) }}</span>
        </div>

        <div class="char-block__payment-item">
          <span class="payment-title">{{ "ANALYTICS_PAGE.TOTAL_COMMISSION" | translate }}</span>
          <span class="payment-currency">{{ "₸" + totalCommision.toFixed(2) }}</span>
        </div>
      </div>

      <div class="char-block__filter-1">
        <button
          [class.active]="barStates.has(barState.AllPayments)"
          (click)="setData(barState.AllPayments)"
          class="char-block__filter-item item-1">
          {{ "ANALYTICS_PAGE.ALL_PAYMENTS" | translate }}
        </button>

        <button
          [class.active]="barStates.has(barState.Commision)"
          (click)="setData(barState.Commision)"
          class="char-block__filter-item item-2">
          {{ "ANALYTICS_PAGE.COMMISSION" | translate }}
        </button>
      </div>
    </div>

    <div
      class="char-block__canvas"
      style="max-width: calc(100% - 10px); max-height: 215px">
      <canvas id="bar"></canvas>
    </div>
    <div class="char-block__filter-2">
      <button
        [class.active]="barStates.has(barState.LinkPayment)"
        (click)="setData(barState.LinkPayment)"
        class="char-block__filter-item item-3">
        {{ "ANALYTICS_PAGE.PAYMENT_LINK" | translate }}<span class="percent">{{ percents?.linkSum }} %</span>
      </button>
      <button
        [class.active]="barStates.has(barState.QrPayment)"
        (click)="setData(barState.QrPayment)"
        class="char-block__filter-item item-4">
        {{ "ANALYTICS_PAGE.QR_PAY" | translate }}<span class="percent">{{ percents?.qrSum }} %</span>
      </button>

      <button
        [class.active]="barStates.has(barState.RecurringPayment)"
        (click)="setData(barState.RecurringPayment)"
        class="char-block__filter-item item-5">
        {{ "ANALYTICS_PAGE.RECCURRENT_PAY" | translate }}<span class="percent">{{ percents?.recurringSum }} %</span>
      </button>

      <button
        [class.active]="barStates.has(barState.SitePayment)"
        (click)="setData(barState.SitePayment)"
        class="char-block__filter-item item-6">
        {{ "ANALYTICS_PAGE.SITE_PAY" | translate }}
        <span class="percent">{{ percents?.websiteSum }} %</span>
      </button>
    </div>
  </div>
</div>
